// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PackagesWidget-module--wrapper--1hNvk","card":"PackagesWidget-module--card--2-SkZ"};